export default {
    selectedvehicle(state, payload) {
        state.selectedvehicle = payload.selectedvehicle;
    },
    selectedyear(state, payload) {
        state.selectedyear = payload.selectedyear;
    },
    selectedmake(state, payload) {
        state.selectedmake = payload;
    },
    selectedmodel(state, payload) {
        state.selectedmodel = payload;
    },
    selectedengine(state, payload) {
        state.selectedengine = payload;
    },
    selectedcategories(state, payload) {
        state.selectedcategories = payload;
    },
    selectedgroups(state, payload) {
        state.selectedgroups = payload;
    },
    selectedquestions(state, payload) {
        state.selectedquestions = payload;
    },
    savedvehiclelist(state, payload) {
        state.savedvehiclelist = payload;
    },
    newsavedvehicleadded(state, payload) {
        state.newsavedvehicleadded = payload;
    },
    clearSelectedVehicle(state) {
        state.selectedvehicle = 0, state.selectedyear = 0; 
        state.selectedmake = {}, state.selectedmodel = {}, state.selectedengine = {};
        state.selectedcategories = [], state.selectedgroups = [], state.selectedquestions = [];
    },

    setKit_vehicle(state, payload) {
        state.kit_vehicle = payload;
    },

    setIndustry_sels(state, payload){
        state.industry_sels = payload;
    },
}